import * as React from 'react'
import {Util} from 'yougile-util'
import {useBoolean, useGlobalKeyDown} from '@containers/hooks'
import {Dialog, DialogProps} from '../../components/common/base/dialog/dialog'
import {UIElement} from '../model/ui-element'
import {ApiElement} from './api-element'

export interface DialogParams extends DialogProps {
  element: UIElement
}

export const ApiDialogCtl = {
  open: (_params: DialogParams) => {
    //
  },
  close: () => {
    //
  },
  rerender: (_props: Partial<DialogProps>) => {
    //
  }
}

export const ApiDialog = () => {
  const bem = Util.bemFrom('api-dialog')
  const isOpen = useBoolean(false)

  const [elem, setElem] = React.useState<UIElement | undefined>(undefined)
  const [popupProps, setPopupProps] = React.useState<DialogProps | undefined>()
  // const forceUpdate = useForceUpdate()

  ApiDialogCtl.open = params => {
    const {element, ...rest} = params
    setElem(element)
    setPopupProps(rest)
    isOpen.turnOn()
  }
  const close = () => {
    isOpen.turnOff()
  }
  ApiDialogCtl.close = close

  ApiDialogCtl.rerender = (props: DialogProps) => {
    setPopupProps({...popupProps, ...props})
  }

  useGlobalKeyDown({
    escape: () => {
      const open = isOpen.value
      ApiDialogCtl.close()
      return open
    }
  })

  if (!popupProps) {
    return null
  }

  return (
    <div className={bem()}>
      {isOpen.value && (
        <Dialog {...popupProps} close={close}>
          {!!elem && <ApiElement element={elem} />}
        </Dialog>
      )}
    </div>
  )
}
